<template>
	<div class="floating-button-pos">
		<div class="position-relative" :style="styles">
			<b-button
				class="floating-button"
				@click="!loadingShow ? handleClick() : ''"
				:class="!loadingShow ? 'pointer' : ''"
			>
				<slot
					>Write with Hire3x
					<img
						class="ml-1"
						src="../../assets/newdesign/dashboard/newUploadModal/Ai.svg"
						alt=""
				/></slot>
			</b-button>
			<div
				v-if="loadingShow"
				class="floating-button loader-class defaultCursor"
			>
				<Loader />
			</div>
		</div>
	</div>
</template>

<script>
import Loader from "@/components/fixedcomponents/Loader.vue";

export default {
	name: "FloatingButton",
	data() {
		return {
			// loadingShow: true,
		};
	},
	props: {
		loadingShow: Boolean,
		styles: Object,
	},
	methods: {
		handleClick() {
			this.$emit("button-click");
		},
	},
	components: {
		Loader,
	},
};
</script>

<style scoped>
.floating-button {
	position: absolute;
	width: 136px;
	padding: 3px;
	height: 27px;
	border-radius: 20px;
	background-color: var(--bg-proTheme);
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-style: italic;
	font-weight: 500;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	z-index: 7;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	transition: all 1s ease;
}

.floating-button:focus {
	outline: none;
	background-color: var(--bg-proTheme);
}
.floating-button.btn-secondary:not(:disabled):not(.disabled):active,
.floating-button.btn-secondary:not(:disabled):not(.disabled).active,
.show > .floating-button.btn-secondary.dropdown-toggle {
	color: #fff;
	background-color: var(--bg-proTheme);
	border-color: var(--bg-proTheme);
}
@media (max-width: 1028px) {
	.floating-button-pos {
		position: absolute;
		width: 136px;
		bottom: 39px !important;
		right: unset !important;
		left: unset !important;
	}
}
@media (min-width: 1029px) {
	.floating-button-pos {
		position: absolute;
		width: 136px;
		bottom: 40px !important;
		right: 13px !important;
		left: unset !important;
	}
}
</style>
